import { Swiper } from "swiper";
import { Scrollbar } from 'swiper/modules';
import "swiper/css";
import "swiper/css/scrollbar";

window.swiperInstances = window.swiperInstances || [];

document.addEventListener('DOMContentLoaded', () => {
    const swiperContainers = document.querySelectorAll('.swiper')

    swiperContainers.forEach(slider => {
        const swiper = new Swiper(slider, {
            modules: [Scrollbar],
            spaceBetween: 16,
            slidesPerView: 'auto',
            direction: 'horizontal',
            breakpoints: {
                768: {
                    spaceBetween: 50
                }
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                dragSize: 45,
                draggable: true,
            },
        })
        swiperInstances.push(swiper)
    })
})
